import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingScreenProps {
    text: string;
    minHeight?: string;
    alignItems?: string;
    justifyContent?: string;
    marginTop?: string;
    flexDirection?: "row" | "column";
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
    text,
    minHeight = "100vh",
    alignItems = "center",
    justifyContent = "center",
    marginTop = "16px",
    flexDirection = "column"
}) => {
    return (
        <Box
            display="flex"
            justifyContent={justifyContent}
            alignItems={alignItems}
            minHeight={minHeight}
            flexDirection={flexDirection}
        >
            <CircularProgress sx={{ color: "orange", marginRight: "20px" }} />
            <Typography variant="h6" style={{ marginTop: marginTop }}>
                {text}
            </Typography>
        </Box>
    );
};

export default LoadingScreen;
